import { render, staticRenderFns } from "./SurfaceList.vue?vue&type=template&id=2deeb308&scoped=true&"
import script from "./SurfaceList.vue?vue&type=script&lang=js&"
export * from "./SurfaceList.vue?vue&type=script&lang=js&"
import style0 from "./SurfaceList.vue?vue&type=style&index=0&id=2deeb308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deeb308",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
